import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Field } from 'redux-form';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Checkbox from 'material-ui/Checkbox';
import { Checkbox as RFCheckbox } from 'redux-form-material-ui';

import Well from '../../../../components/Well';

class TutorSubjectGrades extends Component {
  render() {
    const { tutor: { approvals }, master } = this.props;
    const approvalsByGradeGroupId = approvals.reduce((acc, approval) => {
      const key = approval.grade.gradeGroup.id;

      if (acc[key] != null) {
        acc[key].push(approval);
      } else {
        acc[key] = [approval];
      }

      return acc;
    }, {});

    const headers = ['Subject', 'Grade', 'Requested', 'Approved'];

    return (
      <div>
        {master.allGradeGroups.edges.map(({ node }) => {
          const approvalsByGradeGroup = approvalsByGradeGroupId[node.id];
          return (
            <Well key={node.id}>
              <h3>{node.name}</h3>

              <Table selectable={false} multiSelectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                  <TableRow>
                    {headers.map(header => (
                      <TableHeaderColumn key={header}>
                        {header}
                      </TableHeaderColumn>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={false}
                >
                  {approvalsByGradeGroup ? (
                    approvalsByGradeGroup.map(approval => (
                      <TableRow key={approval.subjectGradeId}>
                        <TableRowColumn>{approval.subject.name}</TableRowColumn>
                        <TableRowColumn>{approval.grade.name}</TableRowColumn>
                        <TableRowColumn>
                          <Checkbox checked={approval.requested} disabled />
                        </TableRowColumn>
                        <TableRowColumn>
                          <Field
                            component={RFCheckbox}
                            name={approval.subjectGradeId}
                          />
                        </TableRowColumn>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableRowColumn>None Found</TableRowColumn>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Well>
          );
        })}
      </div>
    );
  }
}

export default createFragmentContainer(TutorSubjectGrades, {
  tutor: graphql`
    fragment TutorSubjectGrades_tutor on Tutor {
      approvals {
        approved
        requested
        subjectGradeId
        grade {
          id
          name
          code
          gradeGroup {
            id
            name
          }
        }
        subject {
          id
          name
          description
        }
      }
    }
  `,
  master: graphql`
    fragment TutorSubjectGrades_master on Master {
      allGradeGroups {
        edges {
          node {
            id
            name
            description
          }
        }
      }
      allSubjectGrades {
        edges {
          node {
            id
            grade {
              gradeGroup {
                id
                name
              }
              name
            }
            subject {
              name
            }
          }
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/approval/TutorSubjectGrades.js